module.exports = __webpack_public_path__ + "images/content_loading-5e88dc05.png";